import React, { useState, useEffect } from 'react';
import Cookies from 'js-cookie';
import Team from '../components/Main/Team';
import Blog from '../components/Main/Blog';
import Industries from '../components/Main/Industries';
import Cases from '../components/Main/Cases';
import AboutUs from '../components/Main/AboutUs';
import Cooperation from '../components/Main/Cooperation';
import MobileNav from '../components/Main/MobileNav';
import MainBlock from '../components/Main/MainBlock';
import SlidingMenu from '../components/Main/SlidingMenu';
import PhoneSection from '../components/Main/PhoneSection';
import AuthButtons from '../components/Main/AuthButtons';
import Logo from '../components/Main/Logo';
import LogoImgBlack from '../img/logo/logo2.png'
import BurgerBtnImgB from '..//img/menu/close.png';
import BurgerMenu from '../components/Main//BurgerMenu';
import Services from '../components/Main//Services';
import About from '../components/Main/About'
import Perevozki from '../components/Main/Perevozki'
import Footer from '../components/Main/Footer'
import Partners from '../components/Main/Partners'
import Offices from '../components/Main/Offices'
import Faq from '../components/Main/Faq'
import Video from '../components/Main/Video'
import '../css/style.css'
import '../index.css'
import { BACKEND_URL } from '../consts';


const Main = ({authorized, setAuthorized}) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // useEffect(() => {
  //   const token = Cookies.get('token');
  //   console.log('Token:', token); // Логируем токен
  //   console.log('Token:', document.cookie);
  //   if (token) {
  //       setAuthorized(true);
  //   }
  // }, []);

  const [isMenuOpen, setMenuOpen] = useState(false);

  const toggleMenu = () => {
      setMenuOpen(!isMenuOpen);
  };

  // const BASE_URL = "http://v2691254.hosted-by-vdsina.ru"

  useEffect(() => {
      const fetchData = async () => {
          try {
              const response = await fetch(`${BACKEND_URL}/api/v1/block/main/data`);
              if (!response.ok) {
                  throw new Error('Network response was not ok');
              }
              const fetchData = await response.json();
              setData(fetchData);
              console.log(fetchData)
          } catch (error) {
              setError(error.message);
          } finally {
              setLoading(false);
          }
      };

      fetchData();
  }, []);

  if (loading) return <div>Loading...</div>;
  if (error) return <div>Error: {error}</div>;

  return (
        <div className='max-w-[1800px] flex flex-col mx-auto duration-500 ease'>
        {
          data.map((block) => {
            switch (block.type){
              case "industries_block":
                 return (
                <>
                  {/* <AboutUs/> */}
                  <Industries data={block.payload}/>
                </>);
              case "cooperation_block":
                return <Cooperation data={block.payload}/>;
              case "team_block":
                return <Team data={block.payload}/>;
              case "blog_block":
                return <Blog data={block.payload}/>;
              case "cases_block": 
                  return <Cases data={block.payload}/>;
              case "services_block":
                 return <><Services data={block.payload}/></>;     
              case "about_block":
                 return <About data={block.payload}/>;
              case "perevozki":
               return (
                <>
                 <Perevozki data={block.payload}/>
                </>
               )  
              case "video_block":
               return <Video data={block.payload}/>;
              case "footer_block":
                return <><Footer data={block.payload}/></>; 
              case "faq_block":
                 return <Faq data={block.payload}/>;
              case "partnersANDoffices":
                return(
                 <>
                  <Offices />
                </>   )  
              case "main":
                  return (
                   <>
                  <MobileNav
                  data={block.payload}
                  isOpen={isMenuOpen}
                  toggleMenu={toggleMenu} />
   
                   <MainBlock
                  data={block.payload}
                   authorized={authorized}
                  toggleMenu={toggleMenu}
                  isOpen={isMenuOpen} />
   
                  <SlidingMenu
                       data={block.payload}
                       isOpen={isMenuOpen}
                       onClose={toggleMenu}
                       Logo={Logo}
                       LogoImgBlack={LogoImgBlack}
                       PhoneSection={PhoneSection}
                       AuthButtons={AuthButtons}
                       BurgerMenu={BurgerMenu}
                       BurgerBtnImg={BurgerBtnImgB}
                       authorized={authorized} 
                       setAuthorized={setAuthorized}
                   />
                   </>
                  )
             }
             
            
          })
          
        }
    </div>
    
      );
};

export default Main;
